import { MediaPlusText } from '@design-system/media-plus-text';
import { PageBlock } from '@design-system/page-block';
import React, { FC } from 'react';

import { MediaPlusTextBlockProps } from './models';

const MediaPlusTextBlock: FC<MediaPlusTextBlockProps> = ({
  pageBlock: { heading, ...pageBlockProps },
  ...rest
}) => (
  <PageBlock {...pageBlockProps} className="media-plus-text-block">
    <MediaPlusText {...{ ...rest, heading }} />
  </PageBlock>
);

export default MediaPlusTextBlock;
